// extracted by mini-css-extract-plugin
export default {"QualityAssessmentTemplate":"webpack-pages-DataExtraction-QualityAssessmentTemplate-QualityAssessmentTemplate-module__QualityAssessmentTemplate"};